export class DefaultPhotoRejectReasonsDB
{
    public static reasons = [
        "No Match",
        "No Face Detected",
        "Cropped",
        "Blurred",
        "Low Match Percentage"
    ]
}